import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.order.status.title',
    defaultMessage: 'Order status',
  },
  thankYouTitle: {
    id: 'components.success.thankYouTitle',
    defaultMessage: '{name}, thanks for your order',
  },
  successMessage: {
    id: 'components.success.message',
    defaultMessage: 'We have booked your order successfully.',
  },
  successEmail: {
    id: 'components.success.email',
    defaultMessage: 'An e-mail confirmation has been sent to {email}.',
  },
  message: {
    id: 'components.success.pending.message',
    defaultMessage: "We haven't yet received payment confirmation.",
  },
  emailMessage: {
    id: 'components.success.pending.emailMessage',
    defaultMessage:
      "We'll send you an email at {email} as soon as your bank confirms payment.",
  },
  onHoldMessage: {
    id: 'components.success.onHold',
    defaultMessage:
      'Delivery delay possible: This order will be processed manually by our staff. The dispatch of the goods (or for downloads, the serial number) may therefore be delayed by 1-2 business days. We apologize for the inconvenience and ask for your patience.',
  },
  onHoldIconMessage: {
    id: 'components.success.onHoldIconMessage',
    defaultMessage: 'Delivery delay possible',
  },
  order: {
    id: 'components.success.order',
    defaultMessage: 'Order',
  },
  qty: {
    id: 'components.success.qty',
    defaultMessage: 'Qty',
  },
  shippingHandling: {
    id: 'common.titles.shippingHandling',
    defaultMessage: 'Shipping & Handling',
  },
  freeShipping: {
    id: 'components.success.freeShipping',
    defaultMessage: 'Free',
  },
  orderSubtotal: {
    id: 'shop.cart.subtotal',
    defaultMessage: 'Subtotal',
  },
  discount: {
    id: 'shop.cart.discountLabel',
    defaultMessage: 'Discount',
  },
  appliedTax: {
    id: 'shop.cart.appliedTax',
    defaultMessage: 'Plus tax',
  },
  exTax: {
    id: 'shop.cart.ExTax',
    defaultMessage: 'Excl. Tax',
  },
  inclTax: {
    id: 'shop.cart.IncTax',
    defaultMessage: 'Incl. Tax',
  },
  orderTotal: {
    id: 'shop.cart.grandTotal',
    defaultMessage: 'Order Total',
  },
  orderDetailsButton: {
    id: 'components.success.orderDetailsButton',
    defaultMessage: 'View Order Details',
  },
  number: {
    id: 'components.success.number',
    defaultMessage: '#',
  },
  nativeAccessMessage: {
    id: 'components.success.nativeAccessMessage',
    defaultMessage:
      'We will send you an email once your order has been successfully processed. You can then download your product via {link}.',
  },
  nativeAccess: {
    id: 'components.success.nativeAccess',
    defaultMessage: 'Native Access',
  },
  nextSteps: {
    id: 'components.success.nextSteps',
    defaultMessage: 'Next Steps',
  },
  learnMore: {
    id: 'common.buttons.learnMore',
    defaultMessage: 'Learn More',
  },
  getViaNativeDescription: {
    id: 'components.success.getViaNativeDescription',
    defaultMessage:
      'Access, download, and manage all your products in one place',
  },
  getViaNativeTitle: {
    id: 'components.success.getViaNativeTitle',
    defaultMessage: 'Get {product} via Native Access',
  },
  getNativeAccess: {
    id: 'components.success.getNativeAccess',
    defaultMessage: 'Get Native Access',
  },
});
